import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ROUTE_PATHS } from '../constants';
import {
  AssignReleaseParty,
  ChangeCommercialReleaseVoyage,
  ChangeTerminal,
  ChangeVessel,
  UpdateExpiryDate,
  UseCases,
  SearchContainers,
  CreateCommercialReleaseUploadCsv,
  OverruleCustomsLight,
} from '../pages';
import DisplayNotifications from 'modules/terminal/pages/DisplayNotifications';
import SearchCompanies from '../pages/SearchCompanies';
import { hasPermission } from 'auth/helper';
import { Permission } from 'auth/permissions';

type Props = React.ComponentPropsWithoutRef<'div'> & {};

const BetaRoutes: React.FunctionComponent<Props> = () => {
  return (
    <Routes>
      <Route path={ROUTE_PATHS.CHANGE_TERMINAL} element={<ChangeTerminal />} />
      <Route path={ROUTE_PATHS.UPDATE_EXPIRY_DATE} element={<UpdateExpiryDate />} />
      <Route path={ROUTE_PATHS.UPDATE_VOYAGE} element={<ChangeVessel />} />
      <Route path={ROUTE_PATHS.DISPLAY_NOTIFICATIONS} element={<DisplayNotifications />} />
      <Route
        path={ROUTE_PATHS.BLOCK_VOYAGE}
        element={<ChangeCommercialReleaseVoyage commercialReleaseAction="BLOCK" />}
      />
      <Route
        path={ROUTE_PATHS.UNBLOCK_VOYAGE}
        element={<ChangeCommercialReleaseVoyage commercialReleaseAction="UNBLOCK" />}
      />
      <Route
        path={ROUTE_PATHS.DELETE_VOYAGE}
        element={<ChangeCommercialReleaseVoyage commercialReleaseAction="DELETE" />}
      />
      <Route
        path={ROUTE_PATHS.REVOKE_VOYAGE}
        element={<ChangeCommercialReleaseVoyage commercialReleaseAction="REVOKE" />}
      />
      {hasPermission(Permission.CAN_EDIT) && (
        <>
          <Route
            path={ROUTE_PATHS.CREATE_MULTIPLE_RELEASES_UPLOAD}
            element={<CreateCommercialReleaseUploadCsv commercialReleaseAction="CREATEUPLOADCSV" />}
          />
          <Route path={ROUTE_PATHS.OVERRULE_CUSTOMS_LIGHT} element={<OverruleCustomsLight />} />
        </>
      )}
      <Route path={ROUTE_PATHS.ASSIGN_RELEASE_PARTY} element={<AssignReleaseParty />} />
      <Route path={ROUTE_PATHS.SEARCH_PER_VOYAGE} element={<SearchContainers />} />
      <Route path={ROUTE_PATHS.SEARCH_COMPANIES} element={<SearchCompanies />} />
      <Route path={ROUTE_PATHS.BASE_ROUTE} element={<UseCases />} />
    </Routes>
  );
};

export default BetaRoutes;
